import { IconHospital, IconClima, IconCompras,
  IconHoroscopo, IconPacman, IconLoja, IconXadrez,
  IconAcademia,
  IconImage,
  IconGraduacao,
  IconLaboratorio,
  IconCode
 } from "./icons";

export const translateProjetos = [
  {
    Id: 1,
    Nome: {
      pt: "TLG ADMIN - Gestão de Clínica",
      en: "TLG ADMIN - Clinic Management"
    },
    Descricao: {
      pt: "Sistema de gestão de clínicas médicas com controle de pacientes, agendamentos, médicos e planos de saúde.",
      en: "Medical clinic management system with control over patients, appointments, doctors, and health plans."
    },
    StackPrincipal: "Python",
    Tags: ["Python", "SQLite3"],
    Icone: <IconHospital/>,
    CorTema: "red",
    LinkGit: "https://github.com/tiagolucasoo/clinica",
    LinkDemo: "",
    LinkExe: ""
  },
  {
    Id: 2,
    Nome: {
      pt: "SSEC - Sistema de Sugestão de Compras",
      en: "SSEC - Purchase Suggestion System"
    },
    Descricao: {
      pt: "Sistema para análises de vendas e sugestões de reposição de estoque, com importação de dados.",
      en: "System for sales analysis and inventory replenishment suggestions, with data import."
    },
    StackPrincipal: "Python",
    Tags: ["Python", "SQLite3"],
    Icone: <IconCompras/>,
    CorTema: "purple",
    LinkGit: "https://github.com/tiagolucasoo/ssec",
    LinkDemo: "",
    LinkExe: "https://github.com/tiagolucasoo/ssec/releases/tag/SSEC.exe"
  },
  {
    Id: 3,
    Nome: {
      pt: "Weather Tech",
      en: "Weather Tech"
    },
    Descricao: {
      pt: "Aplicação web para previsão do tempo em tempo real com busca global de cidades.",
      en: "Web application for real-time weather forecasting with global city search."
    },
    StackPrincipal: "JavaScript",
    Tags: ["JavaScript"],
    Icone: <IconClima/>,
    CorTema: "blue",
    LinkGit: "https://github.com/tiagolucasoo/weather_tech",
    LinkDemo: "https://weatherbr.vercel.app",
    LinkExe: ""
  },
  {
    Id: 4,
    Nome: {
      pt: "ScriptImage - Otimizador de Imagens",
      en: "ScriptImage - Image Optimizer & Converter"
    },
    Descricao: {
      pt: "Aplicação desktop em arquitetura MVC para edição, conversão de formatos e otimização de imagens em lote.",
      en: "Desktop application built with MVC architecture for batch image editing, format conversion, and optimization."
    },
    StackPrincipal: "Python",
    Tags: ["Python"],
    Icone: <IconImage/>,
    CorTema: "red",
    LinkGit: "https://github.com/tiagolucasoo/Script-Image",
    LinkDemo: "",
    LinkExe: "https://github.com/tiagolucasoo/Script-Image/releases"
  },
  {
    Id: 5,
    Nome: {
      pt: "MySportItens API",
      en: "MySportItens API"
    },
    Descricao: {
      pt: "API RESTful para gestão de e-commerce esportivo com autenticação JWT, catálogo de produtos, pedidos e carrinho.",
      en: "RESTful API for sports e-commerce management featuring JWT authentication, product catalog, orders, and cart."
    },
    StackPrincipal: "FastAPI",
    Tags: ["FastAPI", "Python", "MongoDB"],
    Icone: <IconAcademia/>,
    CorTema: "purple",
    LinkGit: "https://github.com/tiagolucasoo/MySportsItens-api",
    LinkDemo: "",
    LinkExe: "https://mysportitens-api.vercel.app/docs"
  },
  {
    Id: 6,
    Nome: {
      pt: "Diário de Bordo - Extensão IFPR",
      en: "Logbook - IFPR Extension"
    },
    Descricao: {
      pt: "Aplicação web para documentação e acompanhamento do projeto de extensão em Empreendedorismo no IFPR, com galeria e dashboard de métricas.",
      en: "Web application for documenting and tracking the Entrepreneurship extension project at IFPR, featuring a gallery and metrics dashboard."
    },
    StackPrincipal: "React",
    Tags: ["React"],
    Icone: <IconGraduacao/>,
    CorTema: "blue",
    LinkGit: "https://github.com/tiagolucasoo/ifprlondrina",
    LinkDemo: "",
    LinkExe: "https://ifpr.vercel.app"
  },
  // ─── Projetos menos relevantes para o contexto profissional ─────────────
  // {
  //   Id: 5,
  //   Nome: {
  //     pt: "Consulta de Horóscopo",
  //     en: "Horoscope Consultation"
  //   },
  //   Descricao: {
  //     pt: "Aplicação para cálculo de signo e busca de horóscopo via APIs externas com tradução simultânea.",
  //     en: "Application for zodiac sign calculation and horoscope fetching via external APIs with translation."
  //   },
  //   StackPrincipal: "C#",
  //   Tags: ["C#", ".NET", "REST API"],
  //   Icone: <IconHoroscopo/>,
  //   CorTema: "purple",
  //   LinkGit: "https://github.com/tiagolucasoo/horoscopo",
  //   LinkDemo: "",
  //   LinkExe: ""
  // },
  // {
  //   Id: 7,
  //   Nome: {
  //     pt: "Pac-Man no Terminal",
  //     en: "Terminal Pac-Man"
  //   },
  //   Descricao: {
  //     pt: "Recriação do Pac-Man no terminal com sistema de pontuação, dificuldades e IA para os fantasmas.",
  //     en: "Terminal Pac-Man recreation featuring a scoring system, difficulty levels, and ghost AI."
  //   },
  //   StackPrincipal: "Python",
  //   Tags: ["Python"],
  //   Icone: <IconPacman/>,
  //   CorTema: "yellow",
  //   LinkGit: "https://github.com/tiagolucasoo/pacman",
  //   LinkDemo: "",
  //   LinkExe: "https://github.com/tiagolucasoo/pacman/releases/tag/Exe"
  // },
  // {
  //   Id: 9,
  //   Nome: {
  //     pt: "Xadrez (Console)",
  //     en: "Chess (Console)"
  //   },
  //   Descricao: {
  //     pt: "Jogo de xadrez em terminal com validação de movimentos, xeque-mate e jogadas especiais.",
  //     en: "Terminal chess game with movement validation, checkmate, and special moves."
  //   },
  //   StackPrincipal: "C#",
  //   Tags: ["C#", ".NET"],
  //   Icone: <IconXadrez/>,
  //   CorTema: "indigo",
  //   LinkGit: "https://github.com/tiagolucasoo/xadrez",
  //   LinkDemo: "",
  //   LinkExe: ""
  // },
  // {
  //   Id: 13,
  //   Nome: {
  //     pt: "Rick and Morty List",
  //     en: "Rick and Morty List"
  //   },
  //   Descricao: {
  //     pt: "Aplicação para listagem de personagens consumindo a Rick and Morty API.",
  //     en: "Character listing application consuming the Rick and Morty API."
  //   },
  //   StackPrincipal: "React",
  //   Tags: ["React", "JavaScript", "CSS3"],
  //   Icone: <IconLaboratorio/>,
  //   CorTema: "teal",
  //   LinkGit: "https://github.com/tiagolucasoo/rickandmorty-list",
  //   LinkDemo: "https://rickandmorty-list.vercel.app",
  //   LinkExe: ""
  // },
];
